import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=05bb90fa&scoped=true"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"
import style0 from "./AlertModal.vue?vue&type=style&index=0&id=05bb90fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bb90fa",
  null
  
)

export default component.exports